import React from "react";
import { Form, Col } from "react-bootstrap";
import { ApplicantContainer} from "../unstated/applicant";
import SectionHeader from "../containers/SectionHeader";
import FileUploader from "../common/FileUploader";
import documents from "./data/SupportDocuments.json";
import {NO_ADDDITIONAL_SECTION} from "../config/common";
import {XTRACURR_W_FAMBGRD} from "../config/common";
import dayjs from 'dayjs';
import SchRegisterStatus from './SchRegisterStatus';

function GenerateURLField({formURLName, stateFormName, labelMsg, Rows, required}) {

    let app = ApplicantContainer.useContainer();

    return (
        <Col xs={12}>
        <Form.Row className="support-document-url">
            <Col xs={12}>
            <Form.Group as={Col} controlId={formURLName}>            
            <Form.Text>{labelMsg}</Form.Text>      
            </Form.Group>
            </Col>
            <Col xs={12}>      
            <Form.Group as={Col} controlId={formURLName}>
            <Form.Control 
                required={required} name={formURLName} as="textarea" rows={Rows} 
                onChange={e => {app.onChangeInStdValues({...app.inStdValues, [stateFormName]:e.target.value})}} 
                value={app.inStdValues.[stateFormName]} />
            </Form.Group>
            </Col>
        </Form.Row>
        </Col>
        )
}


export default function SupportDocument({invalidMsg, setInvalidMsg}) {

    let app = ApplicantContainer.useContainer();

    // let strSectionHeader = NO_ADDDITIONAL_SECTION.search(app.scholarshipChosen) > 0 ? "SECTION D: SUPPORTING DOCUMENT CHECKLIST" : "SECTION C: SUPPORTING DOCUMENT CHECKLIST";
    // let strSectionHeader = XTRACURR_W_FAMBGRD.search(app.scholarshipChosen) > 0 ? "SECTION E: SUPPORTING DOCUMENT CHECKLIST" : NO_ADDDITIONAL_SECTION.search(app.scholarshipChosen) > 0 ? "SECTION D: SUPPORTING DOCUMENT CHECKLIST" : "SECTION C: SUPPORTING DOCUMENT CHECKLIST";
    //let strSectionHeader = XTRACURR_WO_FAMBGRD.search(app.scholarshipChosen) >= 0 ? "SECTION D: SUPPORTING DOCUMENT CHECKLIST" : XTRACURR_W_FAMBGRD.search(app.scholarshipChosen) >= 0 ? "SECTION E: SUPPORTING DOCUMENT CHECKLIST" : NO_ADDDITIONAL_SECTION.search(app.scholarshipChosen) >= 0 ? "SECTION D: SUPPORTING DOCUMENT CHECKLIST" : "SECTION C: SUPPORTING DOCUMENT CHECKLIST";

    let strSectionHeader =
    XTRACURR_W_FAMBGRD.search(app.scholarshipChosen) > 0
    ? "SECTION E: SUPPORTING DOCUMENT CHECKLIST"
    : NO_ADDDITIONAL_SECTION.search(app.scholarshipChosen) > 0
      ? "SECTION D: SUPPORTING DOCUMENT CHECKLIST"
      : "SECTION C: SUPPORTING DOCUMENT CHECKLIST";

    let [uploadFiles_SPM_OLEVEL_OSSC, setUploadFiles_SPM_OLEVEL_OSSC] = React.useState([]);
    let [uploadFiles_SPM_OLEVEL_UEC, setUploadFiles_SPM_OLEVEL_UEC] = React.useState([]);
    let [uploadFiles_STPM_PREU_MAT_DIP_UEC, setUploadFiles_STPM_PREU_MAT_DIP_UEC] = React.useState([]);
    let [uploadFiles_SPM_STPM_PREU, setUploadFiles_SPM_STPM_PREU] = React.useState([]);
    let [uploadFiles_EXAM_RESULTS, setUploadFiles_EXAM_RESULTS] = React.useState([]);
    let [uploadFiles_EXTRACURRICULAR_CERTS, setUploadFiles_EXTRACURRICULAR_CERTS] = React.useState([]);
    let [uploadFiles_CV_ACHIEVEMENTS, setUploadFiles_CV_ACHIEVEMENTS] = React.useState([]);
    let [uploadFiles_SPORT_CERTS, setUploadFiles_SPORT_CERTS] = React.useState([]);
    let [uploadFiles_SPORTS_DOC, setUploadFiles_SPORTS_DOC] = React.useState([]);
    let [uploadFiles_SPORTS_VERIF_LETT_MSN, setUploadFiles_SPORTS_VERIF_LETT_MSN] = React.useState([]);
    let [uploadFiles_SPORTS_VERIF_LETT_NHC, setUploadFiles_SPORTS_VERIF_LETT_NHC] = React.useState([]);
    let [uploadFiles_SPORT_PORTFOLIO, setUploadFiles_SPORT_PORTFOLIO] = React.useState([]);
    let [uploadFiles_SPORTS_RECOMMEND_LETTER, setUploadFiles_SPORTS_RECOMMEND_LETTER] = React.useState([]);
    let [uploadFiles_LEAVE_CERT_TESTIMONIALS, setUploadFiles_LEAVE_CERT_TESTIMONIALS] = React.useState([]);
    let [uploadFiles_MUSIC_CERTS, setUploadFiles_MUSIC_CERTS] = React.useState([]);
    let [uploadFiles_PARENT_INCOME_TAX, setUploadFiles_PARENT_INCOME_TAX] = React.useState([]);
    let [uploadFiles_PARENT_PAY_SLIP, setUploadFiles_PARENT_PAY_SLIP] = React.useState([]);
    let [uploadFiles_PARENT_EPF, setUploadFiles_PARENT_EPF] = React.useState([]);
    let [uploadFiles_DEGREEE_TRANSCRIPTS, setUploadFiles_DEGREEE_TRANSCRIPTS] = React.useState([]);
    let [uploadFiles_MASTER_TRANSCRIPTS, setUploadFiles_MASTER_TRANSCRIPTS] = React.useState([]);
    let [uploadFiles_HIGHEST_QUALIFICATION, setUploadFiles_HIGHEST_QUALIFICATION] = React.useState([]);
    let [uploadFiles_HIGHEST_QUALIFICATION_INT, setUploadFiles_HIGHEST_QUALIFICATION_INT] = React.useState([]);
    let [uploadFiles_HIGHEST_QUALIFICATION_MIX, setUploadFiles_HIGHEST_QUALIFICATION_MIX] = React.useState([]);
    let [uploadFiles_ART_PORTFOLIO, setUploadFiles_ART_PORTFOLIO] = React.useState([]);
    let [uploadFiles_FASHION_PORTFOLIO, setUploadFiles_FASHION_PORTFOLIO] = React.useState([]);
    let [uploadFiles_LETTER_INTENTS, setUploadFiles_LETTER_INTENTS] = React.useState([]);
    let [uploadFiles_CAREER_PORTFOLIO, setUploadFiles_CAREER_PORTFOLIO] = React.useState([]);
    let [uploadFiles_IDENTITY_CARD, setUploadFiles_IDENTITY_CARD] = React.useState([]);
    
    let Scholar = documents.[app.scholarshipChosen];

    function updInvalidMsgCB(msg) {
      
        setInvalidMsg(msg);
    }


    function upload(DocTypes, files, setFiles, file_ext) {
        return (                    
            <>
                <FileUploader                             
                    setInvalidMsg={updInvalidMsgCB}
                    DocTypes={DocTypes}
                    files={files}
                    setFiles={setFiles}
                    file_ext={file_ext} />
            </>
        ) 
    }

    function getSupportAttributes(short_name, ctr) {

        let document_name = "";
        const MUSIC_TYPES_DESC = (<>
            Remarks:<br />Please follow the below steps to complete the scholarship application:-<br />
            <ol>
                <li>Submit a video clip of music category applied. The video clip can be recorded with handphone/camera/video camera. It does not need to be professionally done.</li>
                <li>Upload the video to Youtube and send the link to scholarship@sunway.edu.my  (with the Subject: Tun Dr Siti Hasmah Mohd Ali Scholarship For Creative Arts and Music OR Sunway Music Scholarship)
                <ul>
                    <li>For instrument - If you play more than one instrument (e.g. piano &amp; violin), submit the video clip for both instruments.</li>
                    <li>The selected song needs to be on par with your grade level e.g. if you are a Grade 8 violinist, please choose a song that is at Grade 8 level. Exam pieces are not advisable.</li>
                    <li>For vocal - You may submit one song in any language of your choice. It has to be with accompaniment.</li>
                </ul>
                </li>
            </ol>
            </>);
        
        const ART_PORTFOLIO_TYPES_DESC = 
            (<>
            Remarks:<br />Please follow the below steps to complete the scholarship application:-<br />
            <ol>
                <li>Submit photo of the portfolio consists of 5 pieces of creative artwork in the category of:-
                    <ul>
                        <li>Photography</li>
                        <li>Model Making</li>
                        <li>Illustration</li>
                        <li>Drawing</li>
                        <li>Multimedia</li>
                        <li>Video</li>
                    </ul>
                </li>
                <li>If the file size is too huge to be attached, please upload the portfolio to Youtube and attached the link in this application</li>
            </ol>
            </>);
        
        const FASHION_PORTFOLIO_TYPES_DESC = 
            (<>
            Remarks:<br />Please follow the below steps to complete the scholarship application:-<br />
            <ol>
                <li>Submit photo of a portfolio related to the fashion design in either of the below category:-
                    <ul>
                        <li>Photography</li>
                        <li>Illustration</li>
                        <li>Any artwork piece related to fashion design</li>
                    </ul>
                </li>
                <li>If the file size is too huge to be attached, please upload the portfolio to Youtube and attached the link in this application</li>
            </ol>
            </>);

        const SPORT_PORTFOLIO_TYPES_DESC = 
            (<>
            Remarks:<br />Please follow the below steps to complete the scholarship application:-<br />
            <ol>
                <li>List of Sports Involvement & Achievement from Year {dayjs().subtract('3','year').format('YYYY').toString()} - {dayjs().format('YYYY').toString()} (kindly submit the certificate of achievement or photo of medal as the supporting document):-
                </li>
                <li>If the file size is too huge to be attached, please upload the portfolio to Youtube and attached the link in this application</li>
            </ol>
            </>);
    
        let support_types = "upload_doc";    
        let file_type = '.jpg, .png, .jpeg, .pdf';    
        let description = "";
        let uploader = "";

        switch(short_name) {     
                
            case "SPM_OLEVEL_OSSC":
                    document_name = "Certified True Copy of the SPM/ O-Level/ Ontario Secondary School Certificate (OSSC)";                               
                    uploader = upload("SPM_OLEVEL_OSSC",uploadFiles_SPM_OLEVEL_OSSC,setUploadFiles_SPM_OLEVEL_OSSC,file_type );                 
                break;
            case "SPM_OLEVEL_UEC":
                    document_name = "Certified True Copy of the SPM/ O-Level/ UEC";                               
                    uploader = upload("SPM_OLEVEL_UEC",uploadFiles_SPM_OLEVEL_UEC,setUploadFiles_SPM_OLEVEL_UEC,file_type );                 
                break;
            case "STPM_PREU_MAT_DIP_UEC":
                    document_name = "Certified True Copy of the STPM/ Foundation/ Pre-University/ Matriculation/ Diploma/ UEC certificate";                     
                    uploader = upload("STPM_PREU_MAT_DIP_UEC",uploadFiles_STPM_PREU_MAT_DIP_UEC,setUploadFiles_STPM_PREU_MAT_DIP_UEC,file_type );               
                break;
            case "SPM_STPM_PREU":
                    document_name = "Certified True Copy of the SPM/ STPM/ Pre-University certificate and relevant documents";                     
                    uploader = upload("SPM_STPM_PREU",uploadFiles_SPM_STPM_PREU,setUploadFiles_SPM_STPM_PREU,file_type );               
                break;
            case "HIGHEST_QUALIFICATION":
                    document_name = (<>Certified True Copy of the Highest academic qualification certificate <br/>(STPM/ Foundation/ Pre-University/ Matriculation/ Diploma/ UEC certificate/ SPM/ O-Level/ Ontario Secondary School Certificate (OSSC))</>);  
                    uploader = upload("HIGHEST_QUALIFICATION",uploadFiles_HIGHEST_QUALIFICATION,setUploadFiles_HIGHEST_QUALIFICATION,file_type );               
                break;
            case "HIGHEST_QUALIFICATION_INT":
                    document_name = (<>Certified True Copy of the Highest academic qualification certificate <br/>Please obtained the Certified True Copy of your academic qualification certificate from the Sunway International Office before the submission.</>);
                    uploader = upload("HIGHEST_QUALIFICATION_INT",uploadFiles_HIGHEST_QUALIFICATION_INT,setUploadFiles_HIGHEST_QUALIFICATION_INT,file_type );               
                break; 
            case "HIGHEST_QUALIFICATION_MIX":
                    document_name = (<>Certified True Copy of the Highest academic qualification certificate <br/>(STPM/ Foundation/ Pre-University/ Matriculation/ Diploma/ UEC certificate/ SPM/ O-Level/ Ontario Secondary School Certificate (OSSC))<br/>For international students, please obtained the Certified True Copy of your academic qualification certificate from the Sunway International Office before the submission.</>);
                    uploader = upload("HIGHEST_QUALIFICATION_MIX",uploadFiles_HIGHEST_QUALIFICATION_MIX,setUploadFiles_HIGHEST_QUALIFICATION_MIX,file_type );               
                break; 
            case "EXAM_RESULTS":
                    document_name = "Certified True Copy of All results obtained in college including the latest results";  
                    uploader = upload("EXAM_RESULTS",uploadFiles_EXAM_RESULTS,setUploadFiles_EXAM_RESULTS,file_type );               
                break;
            case "EXTRACURRICULAR_CERTS":
                document_name = "Certified True Copy of All extracurricular activities certificates";
                uploader = upload("EXTRACURRICULAR_CERTS",uploadFiles_EXTRACURRICULAR_CERTS,setUploadFiles_EXTRACURRICULAR_CERTS,file_type );               
               break;
            case "CV_ACHIEVEMENTS":
                    document_name = "Curriculum Vitae (CV) achievements";
                    uploader = upload("CV_ACHIEVEMENTS",uploadFiles_CV_ACHIEVEMENTS,setUploadFiles_CV_ACHIEVEMENTS,file_type );                              
                break;
            case "SPORT_CERTS":
                    document_name = "Certified True Copy of All sports achievement certificates";
                    uploader = upload("SPORT_CERTS",uploadFiles_SPORT_CERTS,setUploadFiles_SPORT_CERTS,file_type );               
                break;
            case "SPORTS_DOC":
                    document_name = "Relevant document(s) from the Sports Board or Association";
                    uploader = upload("SPORTS_DOC",uploadFiles_SPORTS_DOC,setUploadFiles_SPORTS_DOC,file_type );
                break;
            case "SPORTS_VERIF_LETT_MSN":
                    document_name = "National Athlete Status Verification letter from Majlis Sukan Negara";
                    uploader = upload("SPORTS_VERIF_LETT_MSN",uploadFiles_SPORTS_VERIF_LETT_MSN,setUploadFiles_SPORTS_VERIF_LETT_MSN,file_type );
                break;
            case "SPORTS_VERIF_LETT_NHC":
                    document_name = "National Athlete Status Verification letter from the National Head Coach";
                    uploader = upload("SPORTS_VERIF_LETT_NHC",uploadFiles_SPORTS_VERIF_LETT_NHC,setUploadFiles_SPORTS_VERIF_LETT_NHC,file_type );
                break;
           
            case "SPORTS_RECOMMEND_LETTER":            
                    document_name = "Recommendation Letter from State/ National coach";
                    uploader = upload("SPORTS_RECOMMEND_LETTER",uploadFiles_SPORTS_RECOMMEND_LETTER,setUploadFiles_SPORTS_RECOMMEND_LETTER,file_type );
                break;
            case "LEAVE_CERT_TESTIMONIALS":            
                    document_name = "Certified True Copy of the School leaving certificates and testimonials";
                    uploader = upload("LEAVE_CERT_TESTIMONIALS",uploadFiles_LEAVE_CERT_TESTIMONIALS,setUploadFiles_LEAVE_CERT_TESTIMONIALS,file_type );
                break;
            case "MUSIC_CERTS":
                    document_name = "Certified True Copy of the Music certificates or other relevant documents";
                    uploader = upload("MUSIC_CERTS",uploadFiles_MUSIC_CERTS,setUploadFiles_MUSIC_CERTS,file_type );              
                break;    
            case "PARENT_INCOME_TAX":
                    document_name = "Certified True Copy of Parents’/ guardian’s latest Income Tax Statement";
                    uploader = upload("PARENT_INCOME_TAX",uploadFiles_PARENT_INCOME_TAX,setUploadFiles_PARENT_INCOME_TAX,file_type );                      
                break;
            case "PARENT_PAY_SLIP":
                    document_name = "Certified True Copy of Latest 3 consecutive months’ salary slips/ any other proof of income. For retirees, the last drawn pay slip must be enclosed.";
                    uploader = upload("PARENT_PAY_SLIP",uploadFiles_PARENT_PAY_SLIP,setUploadFiles_PARENT_PAY_SLIP,file_type );                                  
                break;
            case "PARENT_EPF":
                    document_name = "Certified True Copy of Latest EPF Statement";
                    uploader = upload("PARENT_EPF",uploadFiles_PARENT_EPF,setUploadFiles_PARENT_EPF,file_type );                                  
                break;     
            case "DEGREEE_TRANSCRIPTS":
                    document_name = "Certified True Copy of the Bachelor Degree Certificate and Transcripts";
                    uploader = upload("DEGREEE_TRANSCRIPTS",uploadFiles_DEGREEE_TRANSCRIPTS,setUploadFiles_DEGREEE_TRANSCRIPTS,file_type );             
                break;
            case "MASTER_TRANSCRIPTS":
                    document_name = "Certified True Copy of the Master’s Degree Certificate and Transcripts";
                    uploader = upload("MASTER_TRANSCRIPTS",uploadFiles_MASTER_TRANSCRIPTS,setUploadFiles_MASTER_TRANSCRIPTS,file_type );             
                break;
            case "LETTER_INTENTS":
                    document_name = "Letter of Intent for applying for the programme";
                    uploader = upload("LETTER_INTENTS",uploadFiles_LETTER_INTENTS,setUploadFiles_LETTER_INTENTS,file_type );             
                break;
            case "CAREER_PORTFOLIO":
                    document_name = (<>Career Portfolio<br/>(Evidence of work experience, career progression, current job responsibilities, awards and achievements, training and development, and any other supporting evidence that substantiates distinguished professional achievements.)</>);
                    uploader = upload("CAREER_PORTFOLIO",uploadFiles_CAREER_PORTFOLIO,setUploadFiles_CAREER_PORTFOLIO,file_type );             
                break;
            case "IDENTITY_CARD":
                    document_name = "Identity Card";                     
                    uploader = upload("IDENTITY_CARD",uploadFiles_IDENTITY_CARD,setUploadFiles_IDENTITY_CARD,file_type );      
                break;
            case "ART_PORTFOLIO":
                document_name = "Portfolio Link";

                uploader =(                                        
                    <>
                        
                    <FileUploader                            
                        setInvalidMsg={updInvalidMsgCB}                         
                        DocTypes="ART_PORTFOLIO"
                        files={uploadFiles_ART_PORTFOLIO}
                        setFiles={setUploadFiles_ART_PORTFOLIO}
                        file_ext={file_type} />
                    <br/>
                    <GenerateURLField 
                        formURLName = "formART_PORTFOLIO_URL"
                        stateFormName = "frPortfolioURL"
                        labelMsg = "URL (Enter the link to your portfolio. You may also submit multiple portfolio links by separating it in multiple line)" 
                        Rows = "3"
                        required = ""
                    />              
                      
                    </>
                ) 
                description = ART_PORTFOLIO_TYPES_DESC;
                support_types = "url";
                
                break;
            case "FASHION_PORTFOLIO":
                document_name = "Portfolio Link";

                uploader =(                                        
                    <>
                        
                    <FileUploader                            
                        setInvalidMsg={updInvalidMsgCB}                         
                        DocTypes="FASHION_PORTFOLIO"
                        files={uploadFiles_FASHION_PORTFOLIO}
                        setFiles={setUploadFiles_FASHION_PORTFOLIO}
                        file_ext={file_type} />
                    <br/>
                    <GenerateURLField 
                        formURLName = "formFASHION_PORTFOLIO_URL"
                        stateFormName = "frPortfolioURL"
                        labelMsg = "URL (Enter the link to your portfolio. You may also submit multiple portfolio links by separating it in multiple line)" 
                        Rows = "3"
                        required = ""
                    />              
                        
                    </>
                ) 
                description = FASHION_PORTFOLIO_TYPES_DESC;
                support_types = "url";
                
                break;
            case "SPORT_PORTFOLIO":
                    document_name = "Portfolio Link";
    
                    uploader =(                                        
                        <>
                            
                        <FileUploader                            
                            setInvalidMsg={updInvalidMsgCB}                         
                            DocTypes="SPORT_PORTFOLIO"
                            files={uploadFiles_SPORT_PORTFOLIO}
                            setFiles={setUploadFiles_SPORT_PORTFOLIO}
                            file_ext={file_type} />
                        <br/>
                        <GenerateURLField 
                            formURLName = "formSPORT_PORTFOLIO_URL"
                            stateFormName = "frPortfolioURL"
                            labelMsg = "URL (Enter the link to your portfolio. You may also submit multiple portfolio links by separating it in multiple line)" 
                            Rows = "3"
                            required = ""
                        />              
                          
                        </>
                    ) 
                    description = SPORT_PORTFOLIO_TYPES_DESC;
                    support_types = "url";
                    
                    break;    
            case "MUSIC_TRACK":
                document_name = "Video Clip Link";
                uploader =(                    
                    <>
                    <GenerateURLField 
                        formURLName = "formMUSIC_TRACK_URL"
                        stateFormName = "frVideoURL"
                        labelMsg = "URL (Enter the link to your recorded video clip. You may also submit multiple video links by separating it in multiple line)" 
                        Rows = "3"
                        required = "required"
                    />
                    </>
                )
                description = MUSIC_TYPES_DESC;
                support_types = "url";
                break;    
            default:
                break;                    
        } 

        return (<>        
        <Form.Row>                
            <Col xs={12}>
            <Form.Row>                    
                <Form.Group as={Col}>
                <Form.Label className=""> {document_name}</Form.Label>      
                </Form.Group>
            </Form.Row>
            </Col>
            {description !== "" && 
            <Col xs={12}>
            <Form.Row>                    
                <Form.Group as={Col}>
                <Form.Text >{description}</Form.Text>      
                </Form.Group>
            </Form.Row>
            </Col>}                
            {support_types !== "" && 
            <Col xs={12}>
            <Form.Row>                    
                <Form.Group as={Col}>
                {uploader}      
                </Form.Group>
            </Form.Row>
            </Col>}
    </Form.Row>
                 
        </>);
    }
    
if( app.scholarshipChosen) {
    if(Scholar !== undefined){
        return(                        
        <>
        <SectionHeader strSectionHeader={strSectionHeader} />
        <div className='add-clause2'>Please ensure that the academic transcript file is NOT password protected and is unlocked before uploading.</div>
        <ol className="support-documents">
        {Object.values(Scholar).map((key,index) => 
        <li key={key}>
        {getSupportAttributes(key, ++index)}
        </li>
        )}
        </ol>
        </>      
        );
    }else{
        return (<></>); 
    }
} else {
    return (<></>);
}
    
}

        